/** Cuentas que no aplican a esta cooperativa; se ocultan (no se eliminan) en el Excel de Anexo 3. */
export const ANEXO3_CUENTAS_OCULTAS = new Set<string>([
  '4', // ACTIVOS Y PASIVOS CONTINGENTES
  '7', // CUENTAS DE ORDEN Y REGISTRO
  '109', // ACTIVOS DE INVERSIÓN
  '203', // OTRAS EXIGIBILIDADES
  '401', // ACTIVOS CONTINGENTES
  '402', // PASIVOS CONTINGENTES
  '701', // VALORES Y BIENES CEDIDOS EN GARANTÍA
  '711', // DOCUMENTOS Y VALORES EN CONSIGNACIÓN
  '1012', // MONEDA EXTRANJERA
  '1022', // MONEDA EXTRANJERA
  '1032', // MONEDA EXTRANJERA
  '1042', // MONEDA EXTRANJERA
  '1052', // MONEDA EXTRANJERA
  '1082', // MONEDA EXTRANJERA
  '1091', // MONEDA NACIONAL
  '1102', // MONEDA EXTRANJERA
  '2012', // MONEDA EXTRANJERA
  '2022', // MONEDA EXTRANJERA
  '2031', // MONEDA NACIONAL
  '2032', // MONEDA EXTRANJERA
  '2042', // MONEDA EXTRANJERA
  '2052', // MONEDA EXTRANJERA
  '2062', // MONEDA EXTRANJERA
  '4011', // MONEDA NACIONAL
  '4012', // MONEDA EXTRANJERA
  '4021', // MONEDA NACIONAL
  '4022', // MONEDA EXTRANJERA
  '7011', // MONEDA NACIONAL
  '7012', // MONEDA EXTRANJERA
  '7022', // MONEDA EXTRANJERA
  '7052', // MONEDA EXTRANJERA
  '7072', // MONEDA EXTRANJERA
  '7082', // MONEDA EXTRANJERA
  '7092', // MONEDA EXTRANJERA
  '7102', // MONEDA EXTRANJERA
  '7111', // MONEDA NACIONAL
  '7112', // MONEDA EXTRANJERA
  '101101.04', // Cheques y Valores al Cobro
  '101102', // DEPÓSITOS EN EL BANCO CENTRAL
  '101103.0299', // Transitoria para Efectos del Fondo de Estabilización Cooperativa (FEC)
  '101201', // CAJA
  '101201.01', // Caja Movimiento Diario
  '101201.02', // Caja de Reserva
  '101201.04', // Cheques y Valores al Cobro
  '101202', // DEPÓSITOS EN EL BANCO CENTRAL
  '101203', // DEPÓSITOS EN BANCOS DEL INTERIOR
  '101203.01', // Cuenta de Cheques
  '101203.02', // Cuenta de Ahorro
  '101203.0298', // Disponibilidad en cuentas de ahorro
  '101203.0299', // Transitoria para Efectos del Fondo de Estabilización Cooperativa (FEC)
  '102101.02', // Valores Oficiales
  '102101.0201', // Bonos
  '102101.0202', // Letras
  '102101.0499', // Otras Instituciones
  '102101.0501', // Bursátiles
  '102101.0599', // Inversiones en Otras Instituciones
  '102102.0101', // Valores Oficiales
  '102102.010101', // Bonos
  '102102.010102', // Letras
  '102102.01010101', // Hasta 90 días
  '102102.01010102', // De 91 a 180 días
  '102102.01010103', // De 181 a 365 días
  '102102.01010104', // Más de 365 días
  '102102.01010201', // Hasta 90 días
  '102102.01010202', // De 91 a 180 días
  '102102.01010203', // De 181 a 365 días
  '102102.01010204', // Más de 365 días
  '102102.01020101', // Hasta 90 días
  '102201', // INVERSIONES EN VALORES
  '102201.02', // Valores Oficiales
  '102201.04', // Acciones y Participaciones
  '102201.05', // Valores Diversos
  '102201.0201', // Bonos
  '102201.0202', // Letras
  '102201.0401', // En Instituciones Relacionadas Supervisadas
  '102201.0402', // En Instituciones Relacionadas No Supervisadas
  '102201.0499', // Otras Instituciones
  '102201.0501', // Bursátiles
  '102201.0502', // Depósitos a Plazo
  '102201.0599', // Inversiones en Otras Instituciones
  '102202', // INVERSIONES EN FONDOS ESPECIALES
  '102202.01', // Del Fondo de Estabilización Cooperativa
  '102202.0101', // Valores Oficiales
  '102202.0102', // Valores Diversos
  '102202.010101', // Bonos
  '102202.010102', // Letras
  '102202.010201', // Depósitos a Plazo
  '102202.01010101', // Hasta 90 días
  '102202.01010102', // De 91 a 180 días
  '102202.01010103', // De 181 a 365 días
  '102202.01010104', // Más de 365 días
  '102202.01010201', // Hasta 90 días
  '102202.01010202', // De 91 a 180 días
  '102202.01010203', // De 181 a 365 días
  '102202.01010204', // Más de 365 días
  '102202.01020101', // Hasta 90 días
  '102202.01020102', // De 91 a 180 días
  '102202.01020103', // De 181 a 365 días
  '102202.01020104', // Más de 365 días
  '103101.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103101.17', // Préstamos a Otras Instituciones
  '103101.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103101.0502', // Microcrédito
  '103101.0505', // Créditos con Destino de Vivienda
  '103101.0601', // Agropecuarios
  '103101.0602', // Microcrédito
  '103101.0603', // Comerciales
  '103101.0605', // Créditos con Destino de Vivienda
  '103101.0701', // Agropecuarios
  '103101.0702', // Microcrédito
  '103101.0705', // Créditos con Destino de Vivienda
  '103101.1002', // Microcrédito
  '103101.1101', // Agropecuarios
  '103101.1102', // Microcrédito
  '103101.1201', // Agropecuarios
  '103101.1202', // Microcrédito
  '103101.1203', // Comerciales
  '103101.1205', // Créditos con Destino de Vivienda
  '103101.1301', // Agropecuarios
  '103101.1302', // Microcrédito
  '103101.1304', // Consumo
  '103101.1701', // Cooperativas de Ahorro y Crédito
  '103101.1799', // Otras
  '103101.1802', // RAP
  '103101.1803', // BCIE
  '103101.1804', // BID
  '103101.1899', // Otros
  '103101.2501', // Agropecuarios
  '103101.2502', // Microcrédito
  '103101.2601', // Agropecuarios
  '103101.2602', // Microcrédito
  '103101.2603', // Comerciales
  '103101.2604', // Consumo
  '103101.2605', // Créditos con Destino de Vivienda
  '103102.07', // Préstamos Prendarios
  '103102.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103102.17', // Préstamos a Otras Instituciones
  '103102.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103102.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103102.0502', // Microcrédito
  '103102.0505', // Créditos con Destino de Vivienda
  '103102.0601', // Agropecuarios
  '103102.0602', // Microcrédito
  '103102.0603', // Comerciales
  '103102.0605', // Créditos con Destino de Vivienda
  '103102.0701', // Agropecuarios
  '103102.0702', // Microcrédito
  '103102.0703', // Comerciales
  '103102.0704', // Consumo
  '103102.0705', // Créditos con Destino de Vivienda
  '103102.1001', // Agropecuarios
  '103102.1002', // Microcrédito
  '103102.1101', // Agropecuarios
  '103102.1102', // Microcrédito
  '103102.1105', // Créditos con Destino de Vivienda
  '103102.1201', // Agropecuarios
  '103102.1202', // Microcrédito
  '103102.1203', // Comerciales
  '103102.1205', // Créditos con Destino de Vivienda
  '103102.1301', // Agropecuarios
  '103102.1302', // Microcrédito
  '103102.1305', // Créditos con Destino de Vivienda
  '103102.1701', // Cooperativas de Ahorro y Crédito
  '103102.1799', // Otras
  '103102.1802', // RAP
  '103102.1803', // BCIE
  '103102.1804', // BID
  '103102.1899', // Otros
  '103102.2501', // Agropecuarios
  '103102.2502', // Microcrédito
  '103102.2503', // Comerciales
  '103102.2504', // Consumo
  '103102.2505', // Créditos con Destino de Vivienda
  '103102.2601', // Agropecuarios
  '103102.2602', // Microcrédito
  '103102.2603', // Comerciales
  '103102.2604', // Consumo
  '103102.2605', // Créditos con Destino de Vivienda
  '103103.07', // Préstamos Prendarios
  '103103.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103103.17', // Préstamos a Otras Instituciones
  '103103.18', // Préstamos con Fondos Redescontados
  '103103.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103103.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103103.0505', // Créditos con Destino de Vivienda
  '103103.0601', // Agropecuarios
  '103103.0602', // Microcrédito
  '103103.0603', // Comerciales
  '103103.0605', // Créditos con Destino de Vivienda
  '103103.0701', // Agropecuarios
  '103103.0702', // Microcrédito
  '103103.0703', // Comerciales
  '103103.0704', // Consumo
  '103103.0705', // Créditos con Destino de Vivienda
  '103103.1001', // Agropecuarios
  '103103.1002', // Microcrédito
  '103103.1101', // Agropecuarios
  '103103.1102', // Microcrédito
  '103103.1103', // Comerciales
  '103103.1105', // Créditos con Destino de Vivienda
  '103103.1201', // Agropecuarios
  '103103.1202', // Microcrédito
  '103103.1203', // Comerciales
  '103103.1205', // Créditos con Destino de Vivienda
  '103103.1301', // Agropecuarios
  '103103.1302', // Microcrédito
  '103103.1304', // Consumo
  '103103.1305', // Créditos con Destino de Vivienda
  '103103.1701', // Cooperativas de Ahorro y Crédito
  '103103.1799', // Otras
  '103103.1801', // BANHPROVI
  '103103.1802', // RAP
  '103103.1803', // BCIE
  '103103.1804', // BID
  '103103.1899', // Otros
  '103103.2501', // Agropecuarios
  '103103.2502', // Microcrédito
  '103103.2503', // Comerciales
  '103103.2504', // Consumo
  '103103.2505', // Créditos con Destino de Vivienda
  '103103.2601', // Agropecuarios
  '103103.2602', // Microcrédito
  '103103.2603', // Comerciales
  '103103.2604', // Consumo
  '103103.2605', // Créditos con Destino de Vivienda
  '103104.06', // Préstamos Automáticos
  '103104.07', // Préstamos Prendarios
  '103104.10', // Hipotecarios
  '103104.11', // Préstamos Con Garantía Mixta
  '103104.12', // Préstamos Refinanciados
  '103104.13', // Préstamos Readecuados
  '103104.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103104.17', // Préstamos a Otras Instituciones
  '103104.18', // Préstamos con Fondos Redescontados
  '103104.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103104.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103104.0501', // Agropecuarios
  '103104.0502', // Microcrédito
  '103104.0505', // Créditos con Destino de Vivienda
  '103104.0601', // Agropecuarios
  '103104.0602', // Microcrédito
  '103104.0603', // Comerciales
  '103104.0604', // Consumo
  '103104.0605', // Créditos con Destino de Vivienda
  '103104.0701', // Agropecuarios
  '103104.0702', // Microcrédito
  '103104.0703', // Comerciales
  '103104.0704', // Consumo
  '103104.0705', // Créditos con Destino de Vivienda
  '103104.1001', // Agropecuarios
  '103104.1002', // Microcrédito
  '103104.1003', // Comerciales
  '103104.1004', // Consumo
  '103104.1005', // Créditos para Vivienda
  '103104.1101', // Agropecuarios
  '103104.1102', // Microcrédito
  '103104.1103', // Comerciales
  '103104.1104', // Consumo
  '103104.1105', // Créditos con Destino de Vivienda
  '103104.1201', // Agropecuarios
  '103104.1202', // Microcrédito
  '103104.1203', // Comerciales
  '103104.1204', // Consumo
  '103104.1205', // Créditos con Destino de Vivienda
  '103104.1301', // Agropecuarios
  '103104.1302', // Microcrédito
  '103104.1303', // Comerciales
  '103104.1304', // Consumo
  '103104.1305', // Créditos con Destino de Vivienda
  '103104.1701', // Cooperativas de Ahorro y Crédito
  '103104.1799', // Otras
  '103104.1801', // BANHPROVI
  '103104.1802', // RAP
  '103104.1803', // BCIE
  '103104.1804', // BID
  '103104.1899', // Otros
  '103104.2501', // Agropecuarios
  '103104.2502', // Microcrédito
  '103104.2503', // Comerciales
  '103104.2504', // Consumo
  '103104.2505', // Créditos con Destino de Vivienda
  '103104.2601', // Agropecuarios
  '103104.2602', // Microcrédito
  '103104.2603', // Comerciales
  '103104.2604', // Consumo
  '103104.2605', // Créditos con Destino de Vivienda
  '103201', // VIGENTES
  '103201.05', // Préstamos Fiduciarios
  '103201.06', // Préstamos Automáticos
  '103201.07', // Préstamos Prendarios
  '103201.10', // Hipotecarios
  '103201.11', // Préstamos Con Garantía Mixta
  '103201.12', // Préstamos Refinanciados
  '103201.13', // Préstamos Readecuados
  '103201.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103201.17', // Préstamos a Otras Instituciones
  '103201.18', // Préstamos con Fondos Redescontados
  '103201.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103201.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103201.0501', // Agropecuarios
  '103201.0502', // Microcrédito
  '103201.0503', // Comerciales
  '103201.0504', // Consumo
  '103201.0505', // Créditos con Destino de Vivienda
  '103201.0601', // Agropecuarios
  '103201.0602', // Microcrédito
  '103201.0603', // Comerciales
  '103201.0604', // Consumo
  '103201.0605', // Créditos con Destino de Vivienda
  '103201.0701', // Agropecuarios
  '103201.0702', // Microcrédito
  '103201.0703', // Comerciales
  '103201.0704', // Consumo
  '103201.0705', // Créditos con Destino de Vivienda
  '103201.1001', // Agropecuarios
  '103201.1002', // Microcrédito
  '103201.1003', // Comerciales
  '103201.1004', // Consumo
  '103201.1005', // Créditos para Vivienda
  '103201.1101', // Agropecuarios
  '103201.1102', // Microcrédito
  '103201.1103', // Comerciales
  '103201.1104', // Consumo
  '103201.1105', // Créditos con Destino de Vivienda
  '103201.1201', // Agropecuarios
  '103201.1202', // Microcrédito
  '103201.1203', // Comerciales
  '103201.1204', // Consumo
  '103201.1205', // Créditos con Destino de Vivienda
  '103201.1301', // Agropecuarios
  '103201.1302', // Microcrédito
  '103201.1303', // Comerciales
  '103201.1304', // Consumo
  '103201.1305', // Créditos con Destino de Vivienda
  '103201.1701', // Cooperativas de Ahorro y Crédito
  '103201.1799', // Otras
  '103201.1801', // BANHPROVI
  '103201.1802', // RAP
  '103201.1803', // BCIE
  '103201.1804', // BID
  '103201.1899', // Otros
  '103201.2501', // Agropecuarios
  '103201.2502', // Microcrédito
  '103201.2503', // Comerciales
  '103201.2504', // Consumo
  '103201.2505', // Créditos con Destino de Vivienda
  '103201.2601', // Agropecuarios
  '103201.2602', // Microcrédito
  '103201.2603', // Comerciales
  '103201.2604', // Consumo
  '103201.2605', // Créditos con Destino de Vivienda
  '103202', // ATRASADOS
  '103202.05', // Préstamos Fiduciarios
  '103202.06', // Préstamos Automáticos
  '103202.07', // Préstamos Prendarios
  '103202.10', // Hipotecarios
  '103202.11', // Préstamos Con Garantía Mixta
  '103202.12', // Préstamos Refinanciados
  '103202.13', // Préstamos Readecuados
  '103202.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103202.17', // Préstamos a Otras Instituciones
  '103202.18', // Préstamos con Fondos Redescontados
  '103202.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103202.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103202.0501', // Agropecuarios
  '103202.0502', // Microcrédito
  '103202.0503', // Comerciales
  '103202.0504', // Consumo
  '103202.0505', // Créditos con Destino de Vivienda
  '103202.0601', // Agropecuarios
  '103202.0602', // Microcrédito
  '103202.0603', // Comerciales
  '103202.0604', // Consumo
  '103202.0605', // Créditos con Destino de Vivienda
  '103202.0701', // Agropecuarios
  '103202.0702', // Microcrédito
  '103202.0703', // Comerciales
  '103202.0704', // Consumo
  '103202.0705', // Créditos con Destino de Vivienda
  '103202.1001', // Agropecuarios
  '103202.1002', // Microcrédito
  '103202.1003', // Comerciales
  '103202.1004', // Consumo
  '103202.1005', // Créditos para Vivienda
  '103202.1101', // Agropecuarios
  '103202.1102', // Microcrédito
  '103202.1103', // Comerciales
  '103202.1104', // Consumo
  '103202.1105', // Créditos con Destino de Vivienda
  '103202.1201', // Agropecuarios
  '103202.1202', // Microcrédito
  '103202.1203', // Comerciales
  '103202.1204', // Consumo
  '103202.1205', // Créditos con Destino de Vivienda
  '103202.1301', // Agropecuarios
  '103202.1302', // Microcrédito
  '103202.1303', // Comerciales
  '103202.1304', // Consumo
  '103202.1305', // Créditos con Destino de Vivienda
  '103202.1701', // Cooperativas de Ahorro y Crédito
  '103202.1799', // Otras
  '103202.1801', // BANHPROVI
  '103202.1802', // RAP
  '103202.1803', // BCIE
  '103202.1804', // BID
  '103202.1899', // Otros
  '103202.2501', // Agropecuarios
  '103202.2502', // Microcrédito
  '103202.2503', // Comerciales
  '103202.2504', // Consumo
  '103202.2505', // Créditos con Destino de Vivienda
  '103202.2601', // Agropecuarios
  '103202.2602', // Microcrédito
  '103202.2603', // Comerciales
  '103202.2604', // Consumo
  '103202.2605', // Créditos con Destino de Vivienda
  '103203', // VENCIDOS
  '103203.05', // Préstamos Fiduciarios
  '103203.06', // Préstamos Automáticos
  '103203.07', // Préstamos Prendarios
  '103203.10', // Hipotecarios
  '103203.11', // Préstamos Con Garantía Mixta
  '103203.12', // Préstamos Refinanciados
  '103203.13', // Préstamos Readecuados
  '103203.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103203.17', // Préstamos a Otras Instituciones
  '103203.18', // Préstamos con Fondos Redescontados
  '103203.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103203.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103203.0501', // Agropecuarios
  '103203.0502', // Microcrédito
  '103203.0503', // Comerciales
  '103203.0504', // Consumo
  '103203.0505', // Créditos con Destino de Vivienda
  '103203.0601', // Agropecuarios
  '103203.0602', // Microcrédito
  '103203.0603', // Comerciales
  '103203.0604', // Consumo
  '103203.0605', // Créditos con Destino de Vivienda
  '103203.0701', // Agropecuarios
  '103203.0702', // Microcrédito
  '103203.0703', // Comerciales
  '103203.0704', // Consumo
  '103203.0705', // Créditos con Destino de Vivienda
  '103203.1001', // Agropecuarios
  '103203.1002', // Microcrédito
  '103203.1003', // Comerciales
  '103203.1004', // Consumo
  '103203.1005', // Créditos para Vivienda
  '103203.1101', // Agropecuarios
  '103203.1102', // Microcrédito
  '103203.1103', // Comerciales
  '103203.1104', // Consumo
  '103203.1105', // Créditos con Destino de Vivienda
  '103203.1201', // Agropecuarios
  '103203.1202', // Microcrédito
  '103203.1203', // Comerciales
  '103203.1204', // Consumo
  '103203.1205', // Créditos con Destino de Vivienda
  '103203.1301', // Agropecuarios
  '103203.1302', // Microcrédito
  '103203.1303', // Comerciales
  '103203.1304', // Consumo
  '103203.1305', // Créditos con Destino de Vivienda
  '103203.1701', // Cooperativas de Ahorro y Crédito
  '103203.1799', // Otras
  '103203.1801', // BANHPROVI
  '103203.1802', // RAP
  '103203.1803', // BCIE
  '103203.1804', // BID
  '103203.1899', // Otros
  '103203.2501', // Agropecuarios
  '103203.2502', // Microcrédito
  '103203.2503', // Comerciales
  '103203.2504', // Consumo
  '103203.2505', // Créditos con Destino de Vivienda
  '103203.2601', // Agropecuarios
  '103203.2602', // Microcrédito
  '103203.2603', // Comerciales
  '103203.2604', // Consumo
  '103203.2605', // Créditos con Destino de Vivienda
  '103204', // EN EJECUCIÓN JUDICIAL
  '103204.05', // Préstamos Fiduciarios
  '103204.06', // Préstamos Automáticos
  '103204.07', // Préstamos Prendarios
  '103204.10', // Hipotecarios
  '103204.11', // Préstamos Con Garantía Mixta
  '103204.12', // Préstamos Refinanciados
  '103204.13', // Préstamos Readecuados
  '103204.14', // Préstamos con Garantía Emitida por la SA-FGR
  '103204.17', // Préstamos a Otras Instituciones
  '103204.18', // Préstamos con Fondos Redescontados
  '103204.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '103204.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '103204.0501', // Agropecuarios
  '103204.0502', // Microcrédito
  '103204.0503', // Comerciales
  '103204.0504', // Consumo
  '103204.0505', // Créditos con Destino de Vivienda
  '103204.0601', // Agropecuarios
  '103204.0602', // Microcrédito
  '103204.0603', // Comerciales
  '103204.0604', // Consumo
  '103204.0605', // Créditos con Destino de Vivienda
  '103204.0701', // Agropecuarios
  '103204.0702', // Microcrédito
  '103204.0703', // Comerciales
  '103204.0704', // Consumo
  '103204.0705', // Créditos con Destino de Vivienda
  '103204.1001', // Agropecuarios
  '103204.1002', // Microcrédito
  '103204.1003', // Comerciales
  '103204.1004', // Consumo
  '103204.1005', // Créditos para Vivienda
  '103204.1101', // Agropecuarios
  '103204.1102', // Microcrédito
  '103204.1103', // Comerciales
  '103204.1104', // Consumo
  '103204.1105', // Créditos con Destino de Vivienda
  '103204.1201', // Agropecuarios
  '103204.1202', // Microcrédito
  '103204.1203', // Comerciales
  '103204.1204', // Consumo
  '103204.1205', // Créditos con Destino de Vivienda
  '103204.1301', // Agropecuarios
  '103204.1302', // Microcrédito
  '103204.1303', // Comerciales
  '103204.1304', // Consumo
  '103204.1305', // Créditos con Destino de Vivienda
  '103204.1701', // Cooperativas de Ahorro y Crédito
  '103204.1799', // Otras
  '103204.1801', // BANHPROVI
  '103204.1802', // RAP
  '103204.1803', // BCIE
  '103204.1804', // BID
  '103204.1899', // Otros
  '103204.2501', // Agropecuarios
  '103204.2502', // Microcrédito
  '103204.2503', // Comerciales
  '103204.2504', // Consumo
  '103204.2505', // Créditos con Destino de Vivienda
  '103204.2601', // Agropecuarios
  '103204.2602', // Microcrédito
  '103204.2603', // Comerciales
  '103204.2604', // Consumo
  '103204.2605', // Créditos con Destino de Vivienda
  '104101.02', // Faltantes de Caja
  '104101.08', // Documentos por Cobrar
  '104103', // COMISIONES POR COBRAR
  '104103.05', // Préstamos Fiduciarios
  '104103.06', // Préstamos Automáticos
  '104103.07', // Préstamos Prendarios
  '104103.10', // Préstamos Hipotecarios
  '104103.11', // Préstamos Con Garantía Mixta
  '104103.12', // Préstamos Refinanciados
  '104103.13', // Préstamos Readecuados
  '104103.14', // Préstamos con Garantía Emitida por la SA-FGR
  '104103.17', // Préstamos a Otras Instituciones
  '104103.18', // Préstamos con Fondos Redescontados
  '104103.0501', // Agropecuarios
  '104103.0502', // Microcrédito
  '104103.0503', // Comerciales
  '104103.0504', // Consumo
  '104103.0505', // Créditos con Destino de Vivienda
  '104103.0601', // Agropecuarios
  '104103.0602', // Microcrédito
  '104103.0603', // Comerciales
  '104103.0604', // Consumo
  '104103.0605', // Créditos con Destino de Vivienda
  '104103.0701', // Agropecuarios
  '104103.0702', // Microcrédito
  '104103.0703', // Comerciales
  '104103.0704', // Consumo
  '104103.0705', // Créditos con Destino de Vivienda
  '104103.1001', // Agropecuarios
  '104103.1002', // Microcrédito
  '104103.1003', // Comerciales
  '104103.1004', // Consumo
  '104103.1005', // Créditos para Vivienda
  '104103.1101', // Agropecuarios
  '104103.1102', // Microcrédito
  '104103.1103', // Comerciales
  '104103.1104', // Consumo
  '104103.1105', // Créditos con Destino de Vivienda
  '104103.1201', // Agropecuarios
  '104103.1202', // Microcrédito
  '104103.1203', // Comerciales
  '104103.1204', // Consumo
  '104103.1205', // Créditos con Destino de Vivienda
  '104103.1301', // Agropecuarios
  '104103.1302', // Microcrédito
  '104103.1303', // Comerciales
  '104103.1304', // Consumo
  '104103.1305', // Créditos con Destino de Vivienda
  '104103.1701', // Cooperativas de Ahorro y Crédito
  '104103.1799', // Otras
  '104103.1801', // BANHPROVI
  '104103.1802', // RAP
  '104103.1803', // BCIE
  '104103.1804', // BID
  '104103.1899', // Otros
  '104104.14', // Préstamos con Garantía Emitida por la SA-FGR
  '104104.17', // Préstamos a Otras Instituciones
  '104104.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '104104.0502', // Microcrédito
  '104104.0602', // Microcrédito
  '104104.0605', // Créditos con Destino de Vivienda
  '104104.0701', // Agropecuarios
  '104104.0702', // Microcrédito
  '104104.0705', // Créditos con Destino de Vivienda
  '104104.1002', // Microcrédito
  '104104.1101', // Agropecuarios
  '104104.1102', // Microcrédito
  '104104.1201', // Agropecuarios
  '104104.1202', // Microcrédito
  '104104.1301', // Agropecuarios
  '104104.1302', // Microcrédito
  '104104.1701', // Cooperativas de Ahorro y Crédito
  '104104.1799', // Otras
  '104104.1802', // RAP
  '104104.1803', // BCIE
  '104104.1804', // BID
  '104104.1899', // Otros
  '104104.2501', // Agropecuarios
  '104104.2502', // Microcrédito
  '104104.2601', // Agropecuarios
  '104104.2602', // Microcrédito
  '104104.2603', // Comerciales
  '104104.2604', // Consumo
  '104104.2605', // Créditos con Destino de Vivienda
  '104105', // INTERESES Y DIVIDENDOS SOBRE INVERSIONES POR COBRAR
  '104105.02', // Valores Oficiales
  '104105.04', // Dividendos sobre Acciones y Participaciones
  '104105.05', // Valores Diversos
  '104105.0201', // Bonos
  '104105.0202', // Letras
  '104105.0501', // Bursátiles
  '104105.0502', // Depósitos a Plazo
  '104105.0599', // Inversiones en Otras Instituciones
  '104201', // DEUDORES VARIOS
  '104201.02', // Faltantes de Caja
  '104201.03', // Funcionarios y Empleados
  '104201.05', // Cooperativistas
  '104201.07', // Valores Pendientes de Reembolso por Remesas Familiares Pagadas
  '104201.08', // Documentos por Cobrar
  '104201.99', // Cuentas Varias
  '104203', // COMISIONES POR COBRAR
  '104203.05', // Préstamos Fiduciarios
  '104203.06', // Préstamos Automáticos
  '104203.07', // Préstamos Prendarios
  '104203.10', // Préstamos Hipotecarios
  '104203.11', // Préstamos Con Garantía Mixta
  '104203.12', // Préstamos Refinanciados
  '104203.13', // Préstamos Readecuados
  '104203.14', // Préstamos con Garantía Emitida por la SA-FGR
  '104203.17', // Préstamos a Otras Instituciones
  '104203.18', // Préstamos con Fondos Redescontados
  '104203.0501', // Agropecuarios
  '104203.0502', // Microcrédito
  '104203.0503', // Comerciales
  '104203.0504', // Consumo
  '104203.0505', // Créditos con Destino de Vivienda
  '104203.0601', // Agropecuarios
  '104203.0602', // Microcrédito
  '104203.0603', // Comerciales
  '104203.0604', // Consumo
  '104203.0605', // Créditos con Destino de Vivienda
  '104203.0701', // Agropecuarios
  '104203.0702', // Microcrédito
  '104203.0703', // Comerciales
  '104203.0704', // Consumo
  '104203.0705', // Créditos con Destino de Vivienda
  '104203.1001', // Agropecuarios
  '104203.1002', // Microcrédito
  '104203.1003', // Comerciales
  '104203.1004', // Consumo
  '104203.1005', // Créditos para Vivienda
  '104203.1101', // Agropecuarios
  '104203.1102', // Microcrédito
  '104203.1103', // Comerciales
  '104203.1104', // Consumo
  '104203.1105', // Créditos con Destino de Vivienda
  '104203.1201', // Agropecuarios
  '104203.1202', // Microcrédito
  '104203.1203', // Comerciales
  '104203.1204', // Consumo
  '104203.1205', // Créditos con Destino de Vivienda
  '104203.1301', // Agropecuarios
  '104203.1302', // Microcrédito
  '104203.1303', // Comerciales
  '104203.1304', // Consumo
  '104203.1305', // Créditos con Destino de Vivienda
  '104203.1701', // Cooperativas de Ahorro y Crédito
  '104203.1799', // Otras
  '104203.1801', // BANHPROVI
  '104203.1802', // RAP
  '104203.1803', // BCIE
  '104203.1804', // BID
  '104203.1899', // Otros
  '104204', // INTERESES SOBRE PRÉSTAMOS POR COBRAR
  '104204.05', // Préstamos Fiduciarios
  '104204.06', // Préstamos Automáticos
  '104204.07', // Préstamos Prendarios
  '104204.10', // Préstamos Hipotecarios
  '104204.11', // Préstamos Con Garantía Mixta
  '104204.12', // Préstamos Refinanciados
  '104204.13', // Préstamos Readecuados
  '104204.14', // Préstamos con Garantía Emitida por la SA-FGR
  '104204.17', // Préstamos a Otras Instituciones
  '104204.18', // Préstamos con Fondos Redescontados
  '104204.25', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '104204.26', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '104204.0501', // Agropecuarios
  '104204.0502', // Microcrédito
  '104204.0503', // Comerciales
  '104204.0504', // Consumo
  '104204.0505', // Créditos con Destino de Vivienda
  '104204.0601', // Agropecuarios
  '104204.0602', // Microcrédito
  '104204.0603', // Comerciales
  '104204.0604', // Consumo
  '104204.0605', // Créditos con Destino de Vivienda
  '104204.0701', // Agropecuarios
  '104204.0702', // Microcrédito
  '104204.0703', // Comerciales
  '104204.0704', // Consumo
  '104204.0705', // Créditos con Destino de Vivienda
  '104204.1001', // Agropecuarios
  '104204.1002', // Microcrédito
  '104204.1003', // Comerciales
  '104204.1004', // Consumo
  '104204.1005', // Créditos para Vivienda
  '104204.1101', // Agropecuarios
  '104204.1102', // Microcrédito
  '104204.1103', // Comerciales
  '104204.1104', // Consumo
  '104204.1105', // Créditos con Destino de Vivienda
  '104204.1201', // Agropecuarios
  '104204.1202', // Microcrédito
  '104204.1203', // Comerciales
  '104204.1204', // Consumo
  '104204.1205', // Créditos con Destino de Vivienda
  '104204.1301', // Agropecuarios
  '104204.1302', // Microcrédito
  '104204.1303', // Comerciales
  '104204.1304', // Consumo
  '104204.1305', // Créditos con Destino de Vivienda
  '104204.1701', // Cooperativas de Ahorro y Crédito
  '104204.1799', // Otras
  '104204.1801', // BANHPROVI
  '104204.1802', // RAP
  '104204.1803', // BCIE
  '104204.1804', // BID
  '104204.1899', // Otros
  '104204.2501', // Agropecuarios
  '104204.2502', // Microcrédito
  '104204.2503', // Comerciales
  '104204.2504', // Consumo
  '104204.2505', // Créditos con Destino de Vivienda
  '104204.2601', // Agropecuarios
  '104204.2602', // Microcrédito
  '104204.2603', // Comerciales
  '104204.2604', // Consumo
  '104204.2605', // Créditos con Destino de Vivienda
  '104205', // INTERESES Y DIVIDENDOS SOBRE INVERSIONES POR COBRAR
  '104205.02', // Valores Oficiales
  '104205.04', // Dividendos sobre Acciones y Participaciones
  '104205.05', // Valores Diversos
  '104205.0201', // Bonos
  '104205.0202', // Letras
  '104205.0501', // Bursátiles
  '104205.0502', // Depósitos a Plazo
  '104205.0599', // Inversiones en Otras Instituciones
  '105101.02', // Cuenta Corriente
  '105102.01', // Capital Asignado
  '105201', // FILIALES Y VENTANILLAS
  '105201.01', // Capital Asignado
  '105201.02', // Cuenta Corriente
  '105202', // OFICINA PRINCIPAL CUENTA CORRIENTE
  '105202.01', // Capital Asignado
  '105202.02', // Cuenta Corriente
  '106102.99', // Otros Bienes Muebles
  '107104', // BIENES ARRENDADOS
  '107104.03', // Mobiliario y Equipo
  '107104.04', // Maquinaria y Equipo
  '107104.05', // Equipo de Informática
  '107104.06', // Vehículos
  '108101.02', // Alquileres
  '108101.03', // Anticipos para Viajes
  '108102', // INTERESES Y COMISIONES PAGADAS POR ANTICIPADO
  '108102.01', // Intereses Pagados por Anticipado
  '108102.02', // Comisiones Pagadas por Anticipado
  '108103', // CUENTAS POR AMORTIZAR
  '108103.01', // Gastos de Cooperativa
  '108103.99', // Otras Cuentas por Amortizar
  '108201', // GASTOS PAGADOS POR ANTICIPADO
  '108201.01', // Primas de Seguro
  '108201.02', // Alquileres
  '108201.03', // Anticipos para Viajes
  '108201.04', // Impuestos
  '108201.99', // Otros Gastos Anticipados
  '108202', // INTERESES Y COMISIONES PAGADAS POR ANTICIPADO
  '108202.01', // Intereses Pagados por Anticipado
  '108202.02', // Comisiones Pagadas por Anticipado
  '108219', // OTROS CARGOS DIFERIDOS
  '108219.99', // OTROS CARGOS DIFERIDOS
  '109101', // Bienes Raíces
  '109101.01', // Terrenos
  '109101.02', // Edificios
  '110101.01', // Programas
  '110102', // ACTIVO INTANGIBLE EN PROCESO
  '110201', // PROGRAMAS Y APLICACIONES INFORMÁTICAS
  '110201.01', // Programas
  '110201.02', // Aplicaciones y Licencias
  '110202', // ACTIVO INTANGIBLE EN PROCESO
  '201107', // DOCUMENTOS Y ORDENES DE PAGO
  '201107.02', // Remesas por Pagar
  '201109.01', // Sueldos por Pagar
  '201109.07', // Sobrantes de Caja
  '201109.96', // Contribución Social
  '201109.98', // Aportaciones al Fondo de Seguro de Depósitos
  '201109.0503', // INFOP
  '201109.0504', // Impuestos Municipales
  '201109.0505', // Otras Retenciones
  '201110', // EXCEDENTES POR DISTRIBUIR
  '201110.01', // EXCEDENTES POR DISTRIBUIR
  '201112.02', // Sobre Depósitos de Ahorro
  '201112.03', // Sobre Depósitos a Plazo
  '201112.08', // Sobre Préstamos de Instituciones Financieras Nacionales
  '201112.09', // Sobre Préstamos Redescontados
  '201112.13', // Sobre Préstamos de Instituciones Internacionales
  '201112.99', // Otras Obligaciones
  '201112.0801', // De Bancos
  '201112.0802', // De Sociedades Financieras
  '201112.0803', // De Cooperativas de Ahorro y Crédito
  '201112.0899', // De Otras Instituciones
  '201112.0901', // BANHPROVI
  '201112.0902', // RAP
  '201112.0903', // BCIE
  '201112.0904', // BID
  '201112.0999', // Otros
  '201113', // COMISIONES POR PAGAR
  '201113.05', // Comisiones por Préstamos
  '201113.99', // Otras Comisiones
  '201120', // DOCUMENTOS POR PAGAR
  '201120.01', // DOCUMENTOS POR PAGAR
  '201120.02', // Anticipos Recibidos
  '201207', // DOCUMENTOS Y ORDENES DE PAGO
  '201207.02', // Remesas por Pagar
  '201208', // OBLIGACIONES POR ADMINISTRACIÓN
  '201208.02', // Cuentas por Liquidar por Contratos en Administración
  '201209', // ACREEDORES VARIOS
  '201209.99', // Cuentas Varias
  '201212', // INTERESES POR PAGAR
  '201212.02', // Sobre Depósitos de Ahorro
  '201212.03', // Sobre Depósitos a Plazo
  '201212.08', // Sobre Préstamos de Instituciones Financieras Nacionales
  '201212.09', // Sobre Préstamos Redescontados
  '201212.13', // Sobre Préstamos de Instituciones Internacionales
  '201212.16', // Sobre Aportaciones
  '201212.99', // Otras Obligaciones
  '201212.0801', // De Bancos
  '201212.0802', // De Sociedades Financieras
  '201212.0803', // De Cooperativas de Ahorro y Crédito
  '201212.0899', // De Otras Instituciones
  '201212.0901', // BANHPROVI
  '201212.0902', // RAP
  '201212.0903', // BCIE
  '201212.0904', // BID
  '201212.0999', // Otros
  '201213', // COMISIONES POR PAGAR
  '201213.05', // Comisiones por Préstamos
  '201213.99', // Otras Comisiones
  '201220', // DOCUMENTOS POR PAGAR
  '201220.01', // DOCUMENTOS POR PAGAR
  '201220.02', // Anticipos Recibidos
  '201221', // CUENTAS POR PAGAR
  '201221.02', // Cuentas a Pagar Proveedores
  '201221.03', // Cuentas por Pagar Diversas
  '202103.0304', // Más de 365 días
  '202201', // DEPÓSITOS DE AHORRO
  '202201.01', // De Afiliados Personas Naturales
  '202201.02', // De Afiliados Personas Jurídicas
  '202203', // Depósitos a Plazo
  '202203.01', // De Afiliados Personas Naturales
  '202203.02', // De Afiliados Personas Jurídicas
  '202203.03', // Del Fondo de Estabilización Cooperativa
  '202203.0301', // Hasta 90 días
  '202203.0302', // De 91 a 180 días
  '202203.0303', // De 181 a 365 días
  '202203.0304', // Más de 365 días
  '203103', // CHEQUES EN CIRCULACIÓN
  '203103.01', // Valores de Cheques en Circulación
  '203203', // CHEQUES EN CIRCULACIÓN
  '203203.01', // Valores de Cheques en Circulación
  '204101.02', // RAP
  '204101.03', // BCIE
  '204101.04', // BID
  '204101.99', // Otros
  '204102', // CRÉDITOS Y OBLIGACIONES BANCARIAS
  '204102.02', // Préstamos de Instituciones Internacionales
  '204102.03', // Préstamos de Instituciones Financieras Nacionales
  '204102.0301', // De Bancos
  '204102.0303', // De Sociedades Financieras
  '204102.0304', // De Cooperativas de Ahorro y Crédito
  '204102.0399', // De Otras Instituciones
  '204201', // OBLIGACIONES POR PRÉSTAMOS REDESCONTADOS
  '204201.03', // BCIE
  '204201.04', // BID
  '204201.99', // Otros
  '204202', // CRÉDITOS Y OBLIGACIONES BANCARIAS
  '204202.02', // Préstamos de Instituciones Internacionales
  '204202.03', // Préstamos de Instituciones Financieras Nacionales
  '204202.0301', // De Bancos
  '204202.0303', // De Sociedades Financieras
  '204202.0304', // De Cooperativas de Ahorro y Crédito
  '204202.0399', // De Otras Instituciones
  '205101.01', // Capital Asignado
  '205102.01', // Capital Asignado
  '205201', // FILIALES Y VENTANILLAS
  '205201.01', // Capital Asignado
  '205201.02', // Cuenta Corriente
  '205202', // OFICINA PRINCIPAL CUENTA CORRIENTE
  '205202.01', // Capital Asignado
  '205202.02', // Cuenta Corriente
  '206101.01', // Intereses Recibidos por Anticipado
  '206101.02', // Comisiones Recibidas por Anticipado
  '206101.03', // Rentas Cobradas por Anticipado
  '206104', // DESCUENTOS POR DEVENGAR SOBRE INVERSIONES EN VALORES
  '206104.01', // Descuentos sobre Bonos
  '206107', // INTERESES PENDIENTES DE COBRO SOBRE PRÉSTAMOS READECUADOS
  '206107.01', // Intereses sobre Préstamos Readecuados
  '206201', // VALORES RECIBIDOS POR ANTICIPADO
  '206201.01', // Intereses Recibidos por Anticipado
  '206201.02', // Comisiones Recibidas por Anticipado
  '206201.03', // Rentas Cobradas por Anticipado
  '206201.99', // Otros Valores Recibidos por Anticipado
  '206202', // VALORES PENDIENTES DE APLICACIÓN
  '206202.01', // VALORES PENDIENTES DE APLICACIÓN
  '206204', // DESCUENTOS POR DEVENGAR SOBRE INVERSIONES EN VALORES
  '206204.01', // Descuentos sobre Bonos
  '206207', // INTERESES PENDIENTES DE COBRO SOBRE PRÉSTAMOS READECUADOS
  '206207.01', // Intereses sobre Préstamos Readecuados
  '207101.01', // Agropecuarios
  '207101.02', // Microcrédito
  '207101.03', // Comerciales
  '207101.05', // Créditos con Destino de Vivienda
  '207101.06', // Créditos para Vivienda
  '207102.01', // Agropecuarios
  '207102.02', // Microcrédito
  '207102.03', // Comerciales
  '207102.05', // Créditos con Destino de Vivienda
  '207102.06', // Créditos para Vivienda
  '207107.02', // MUEBLES
  '207108', // DEPRECIACIÓN ACUMULADA DE ACTIVOS ARRENDADOS
  '207108.01', // Activos Arrendados
  '207110', // AMORTIZACIÓN ACUMULADA DE ACTIVOS DE INVERSION
  '207110.01', // Bienes Raíces
  '207111.02', // Activos Intangibles en Proceso
  '207112.02', // Documentos por Cobrar
  '208102.02', // Provisión para Vacaciones
  '208103.01', // Créditos Castigados Readecuados
  '208103.02', // Provisiones para Educación y Capacitación
  '302101', // RESERVAS POR REVALUACIONES
  '302101.01', // Por Revaluaciones
  '302102', // RESERVAS PARA CONTINGENCIAS
  '302102.01', // Para Contingencias
  '302105', // DONACIONES
  '302105.01', // Nacionales
  '302105.02', // Internacionales
  '401102', // CRÉDITOS POR UTILIZAR
  '401102.01', // Préstamos Concedidos por Entregar
  '401102.03', // Márgenes por Utilizar en Líneas de Crédito
  '401103', // OPERACIONES DIVERSAS
  '401103.01', // Otras Actividades Financieras Autorizadas
  '401103.99', // Otras
  '401202', // CRÉDITOS POR UTILIZAR
  '401202.01', // Préstamos Concedidos por Entregar
  '401202.03', // Márgenes por Utilizar en Líneas de Crédito
  '401203', // OPERACIONES DIVERSAS
  '401203.01', // Otras Actividades Financieras Autorizadas
  '401203.99', // Otras
  '402102', // EXIGIBILIDADES CONTRACTUALES
  '402102.01', // Préstamos Concedidos por Entregar
  '402102.03', // Márgenes por Utilizar en Líneas de Crédito
  '402103', // RESPONSABILIDADES DIVERSAS
  '402103.01', // Responsabilidades por Otras Actividades Financieras Autorizadas
  '402103.99', // Otras Responsabilidades
  '402202', // EXIGIBILIDADES CONTRACTUALES
  '402202.01', // Préstamos Concedidos por Entregar
  '402202.03', // Márgenes por Utilizar en Líneas de Crédito
  '402203', // RESPONSABILIDADES DIVERSAS
  '402203.01', // Responsabilidades por Otras Actividades Financieras Autorizadas
  '402203.99', // Otras Responsabilidades
  '701102', // PRÉSTAMOS OBTENIDOS DE INSTITUCIONES FINANCIERAS NACIONALES
  '701102.01', // Cartera Crediticia
  '701102.02', // INMUEBLES
  '701103', // PRÉSTAMOS OBTENIDOS DE INSTITUCIONES INTERNACIONALES
  '701103.01', // Cartera Crediticia
  '701103.02', // INMUEBLES
  '701202', // PRÉSTAMOS OBTENIDOS DE INSTITUCIONES FINANCIERAS NACIONALES
  '701202.01', // Cartera Crediticia
  '701202.02', // INMUEBLES
  '701203', // PRÉSTAMOS OBTENIDOS DE INSTITUCIONES INTERNACIONALES
  '701203.01', // Cartera Crediticia
  '701203.02', // INMUEBLES
  '702106.02', // Propiedades Rurales
  '702106.03', // Inventarios
  '702106.04', // Bienes Agrícolas (No Inventarios)
  '702106.05', // Bienes Industriales (No Inventarios)
  '702106.08', // Valores en Garantía
  '702106.09', // Documentos del Banco Central de Honduras o del Estado de Honduras
  '702106.10', // Garantía Recíproca
  '702106.0201', // Terrenos o Propiedades con Irrigación
  '702106.0202', // Terrenos o Propiedades sin Irrigación
  '702106.0901', // Documentos del Banco Central
  '702106.0902', // Documentos Gubernamentales
  '702206', // VALORACIÓN DE GARANTÍAS
  '702206.01', // Propiedades Urbanas
  '702206.02', // Propiedades Rurales
  '702206.03', // Inventarios
  '702206.04', // Bienes Agrícolas (No Inventarios)
  '702206.05', // Bienes Industriales (No Inventarios)
  '702206.06', // Depósitos en Garantía
  '702206.07', // Vehículos
  '702206.08', // Valores en Garantía
  '702206.09', // Documentos del Banco Central de Honduras o del Estado de Honduras
  '702206.10', // Garantía Recíproca
  '702206.99', // Otros Bienes
  '702206.0104', // Casas
  '702206.0105', // Departamentos
  '702206.0106', // Terrenos
  '702206.0201', // Terrenos o Propiedades con Irrigación
  '702206.0202', // Terrenos o Propiedades sin Irrigación
  '702206.0901', // Documentos del Banco Central
  '702206.0902', // Documentos Gubernamentales
  '703101.02', // Categoría II - Créditos Especialmente Mencionados
  '703101.04', // Categoría IV - Créditos de Dudosa Recuperación
  '703101.05', // Categoría V - Créditos de Pérdida
  '703102', // Microcrédito
  '703102.01', // Categoría I - Créditos Buenos
  '703102.02', // Categoría II - Créditos Especialmente Mencionados
  '703102.03', // Categoría III - Créditos Bajo Norma
  '703102.04', // Categoría IV - Créditos de Dudosa Recuperación
  '703102.05', // Categoría V - Créditos de Pérdida
  '703106', // VIVIENDA
  '703106.01', // Categoría I - Créditos Buenos
  '703106.02', // Categoría II - Créditos Especialmente Mencionados
  '703106.03', // Categoría III - Créditos Bajo Norma
  '703106.04', // Categoría IV - Créditos de Dudosa Recuperación
  '703106.05', // Categoría V - Créditos de Pérdida
  '705201', // DOCUMENTOS Y VALORES
  '705201.01', // Recibidos para su Cobranza
  '707101.0125', // Refinanciamiento por Emergencia Sanitaria COVID-19
  '707101.0126', // Readecuaciones por Emergencia Sanitaria COVID-19
  '707101.012501', // Agropecuarios
  '707101.012502', // Microcrédito
  '707101.012503', // Comerciales
  '707101.012504', // Consumo
  '707101.012505', // Créditos con Destino de Vivienda
  '707101.012601', // Agropecuarios
  '707101.012602', // Microcrédito
  '707101.012603', // Comerciales
  '707101.012604', // Consumo
  '707101.012605', // Créditos con Destino de Vivienda
  '707201', // INTERESES EN SUSPENSO SOBRE OPERACIONES CREDITICIAS
  '707201.01', // Sobre Cartera de Préstamos
  '707201.0125', // Refinanciamiento por Emergencia Sanitaria COVID-19
  '707201.0126', // Readecuaciones por Emergencia Sanitaria COVID-19
  '707201.012501', // Agropecuarios
  '707201.012502', // Microcrédito
  '707201.012503', // Comerciales
  '707201.012504', // Consumo
  '707201.012505', // Créditos con Destino de Vivienda
  '707201.012601', // Agropecuarios
  '707201.012602', // Microcrédito
  '707201.012603', // Comerciales
  '707201.012604', // Consumo
  '707201.012605', // Créditos con Destino de Vivienda
  '708202', // CUENTAS INCOBRABLES CASTIGADAS
  '708202.01', // Cuentas Incobrables Castigadas Años Anteriores
  '708202.02', // Cuentas Incobrables Castigadas Año Actual
  '708299', // OTRAS CUENTAS DE ORDEN Y REGISTRO
  '708299.01', // OTRAS CUENTAS DE ORDEN Y REGISTRO
  '709201', // CRÉDITOS OTORGADOS A PARTES RELACIONADAS
  '710201', // PRÉSTAMOS REDESCONTADOS DE VIVIENDA CON HIPOTECA
  '711101', // DOCUMENTOS Y VALORES EN CONSIGNACIÓN
  '711101.01', // Documentos
  '711101.02', // Valores
  '711201', // DOCUMENTOS Y VALORES EN CONSIGNACIÓN
  '711201.01', // Documentos
  '711201.02', // Valores
]);
